// node modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Query } from '@apollo/client/react/components';
import { gql } from '@apollo/client';

// app modules
import { SearchItemComponent } from 'components/SearchResultsItem';
import Heading from 'components/Heading';
import SearchResultsMatrix from 'components/SearchResultsMatrix';

// app modules: constants
import { CONTENT_TYPES } from 'constants/index';

class RelatedBooks extends Component {
  static propTypes = {
    isbn: PropTypes.string.isRequired,
    variant: PropTypes.string,
  };

  static defaultProps = {
    variant: null,
  };

  static GET_RELATED_BOOKS_QUERY = gql`
    query GetRelatedBooks($isbn: String, $variant: String) {
      RelatedBooks(isbn: $isbn, variant: $variant) {
        image_name
        isbn
        ranking_recommendations
        signature_
        title
      }
    }
  `;

  static renderContent(relatedBooks, variant) {
    if (relatedBooks.length > 0) {
      return (
        <section>
          <Heading level={2} className="margin-bottom-20">
            You might also like... {variant}
          </Heading>
          <SearchResultsMatrix
            ItemComponent={SearchItemComponent.Book}
            itemKey="id"
            itemType={CONTENT_TYPES.BOOK}
            itemWidth={120}
            items={relatedBooks}
            showAll={false}
          />
        </section>
      );
    }

    return null;
  }

  render() {
    const { isbn, variant } = this.props;

    return (
      <Query query={RelatedBooks.GET_RELATED_BOOKS_QUERY} variables={{ isbn, variant }}>
        {({ loading, error, data }) => {
          if (loading) {
            return null;
          }
          if (error) {
            console.error(error.message);
            return null;
          }

          return RelatedBooks.renderContent(data.RelatedBooks, variant);
        }}
      </Query>
    );
  }
}

export default RelatedBooks;
